import { ConfigProvider } from 'antd';
import { EmailTemplateConfig } from '../components/EmailTemplateEditor/EmailTemplateConfig';
import '../index.css'
import App from '../../LayoutMobile'
const Index = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#008385',
          borderRadius: 8,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
        components: {
          Select: {
            optionSelectedBg: '#e6f7f7',
            optionActiveBg: '#f0fafa',
          },
          Button: {
            primaryColor: '#ffffff',
          },
          Tag: {
            defaultBg: '#e6f7f7',
          },
        },
      }}
    >
      <App>
      <EmailTemplateConfig />
      </App>
    </ConfigProvider>
  );
};

export default Index;
